<div class="ca-rbr-section">
    <ng-content />
</div>
